class baseMockModel {
  constructor() {
    this._start()
  }

  async _start() {
    const { default: faker } = await import(
      /* webpackChunkName: "faker" */
      /* webpackPrefetch: true */
      'faker/locale/zh_TW'
      )
    this.faker = faker
    this.init()
  }
  
  init() {}

  /**
   * @param options
   * @param options.max {Number} 目前頁面最多資料筆數
   * @param options.min {Number} 目前頁面最少資料筆數
   */
  createList(options = {}) {
    options  = {
      max: options.max || 20,
      min: options.min || 1,
    }

    let result = []
    const quantity = faker.random.number({ max: options.max, min: options.min })
    if(quantity == 0) return result
    for(let i=1; i<=quantity; i++) {
      result.push(this.item())
    }
    return result
  }

  /**
   * @param options
   * @param options.page {Number} 目前頁數
   * @param options.pages {Number} 總頁數
   * @param options.count {Number} 總資料筆數
   * @param options.max {Number} 目前頁面最多資料筆數
   * @param options.min {Number} 目前頁面最少資料筆數
   */
  createIndex(options = {}) {
    options  = {
      page: options.page || 1,
      pages: options.pages || 15,
      count: options.count || 15,
      max: options.max || 20,
      min: options.min || 1,
    }

    let result = {
      data: this.createList({ max: options.max, min: options.min }),
      pager: {
        page: options.page || 1,
        pages: options.pages || 15,
        count: options.count || 15,
        total: 136,
      },
    }
    return result
  }
}

export default baseMockModel